import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { profileCoinsModal } from '@root/features/profile/profile-coins/atoms/reatom-profile-coins-modal'
import { useAppRoutes } from '@root/features/routing'
import { userConnectionsFollowersModal } from '@root/features/user/user-connections/atoms/user-connections-followers-modal'
import { userConnectionsFollowingsModal } from '@root/features/user/user-connections/atoms/user-connections-followings-modal'
import { UserConnectionsShortItem } from '@root/features/user/user-connections/ui/user-connections-item/user-connections-short-item'
import { Skeleton } from '@root/shared/ui-kit'

import { FollowUserButton } from '../../activity-actions'
import { ActivityKebabActions } from '../../activity-actions/activity-kebab-actions'

import type { FollowerDetail } from '@root/entities/follower-detail'

interface WhoToFollowItemProps {
  followerDetail: FollowerDetail.FollowerDetail
}

export const WhoToFollowItem = ({ followerDetail }: WhoToFollowItemProps) => {
  const { navigateUserProfile: navigateUserProfileRoute } = useAppRoutes()

  const handleNavigateToUserProfile = () =>
    navigateUserProfileRoute(followerDetail.delugeId)

  const [_followersModal, openFollowersModal] = useAtom(
    userConnectionsFollowersModal,
  )
  const [_followingsModal, openFollowingsModal] = useAtom(
    userConnectionsFollowingsModal,
  )
  const [_profileCoinsModal, setProfileCoinsModal] = useAtom(profileCoinsModal)

  return (
    <UserConnectionsShortItem
      followerDetail={followerDetail}
      onNavigateToUserProfile={() => {
        handleNavigateToUserProfile()
      }}
      onNavigateToCoins={() => {
        setProfileCoinsModal({ delugeId: followerDetail.delugeId })
      }}
      onNavigateToFollowers={() => {
        openFollowersModal({
          delugeId: followerDetail.delugeId,
          followers: followerDetail.followersCount,
        })
      }}
      onNavigateToFollowings={() => {
        openFollowingsModal({
          delugeId: followerDetail.delugeId,
          followings: followerDetail.followingCount,
        })
      }}
    >
      <FollowUserButton
        delugeId={followerDetail.delugeId}
        variant="soft"
        size="xxs"
        radius="rounded"
        type="button"
      />
      <ActivityKebabActions
        onNavigateToUserProfile={handleNavigateToUserProfile}
        userShort={followerDetail}
        size="xxs"
      />
    </UserConnectionsShortItem>
  )
}

const LabeledCount = (props: {
  label: string
  count: number
  countMinChars: number
}) => {
  return (
    <LabeledCountRoot>
      <span>{props.label}</span>{' '}
      <LabeledCountCount $countMinChars={props.countMinChars}>
        ({props.count})
      </LabeledCountCount>
    </LabeledCountRoot>
  )
}
LabeledCount.Skeleton = (props: { width: number }) => (
  <LabeledCountRoot>
    <Skeleton.Line width={props.width} />
  </LabeledCountRoot>
)

const LabeledCountRoot = styled.span`
  font-weight: 500;
  font-size: 12px;
  text-transform: capitalize;
`
const LabeledCountCount = styled.span<{ $countMinChars: number }>`
  display: inline-block;
  min-width: ${(x) => x.$countMinChars}ch;
`

WhoToFollowItem.Skeleton = UserConnectionsShortItem.Skeleton
